import {getLoanLibraryLoanStatusTextByValue} from "./loanLibraryLoanUtility";
import {isNullOrUndefined} from "../../../../Utilities/commonUtilities";
import {convertDateToPrintString} from "../../../../Utilities/Types/dateUtilities";
import type { LoanLibraryLoanItem } from './loanLibraryLoan.types';

export const loanLibraryLoanItemModel = (loanLibraryLoanItem: Record<string, any> = {}): LoanLibraryLoanItem => {
    const checkedOutDate = loanLibraryLoanItem.checkedOutDate || null;
    const dueDate = loanLibraryLoanItem.dueDate || null;

    return {
        loanLibraryLoanId: loanLibraryLoanItem.loanLibraryLoanId || null,
        loanLibraryLoanStatus: loanLibraryLoanItem.loanLibraryLoanStatus || null,
        loanStatusText: getLoanLibraryLoanStatusTextByValue(loanLibraryLoanItem.loanLibraryLoanStatus),
        loanLibraryLoanNotes: isNullOrUndefined(loanLibraryLoanItem.loanLibraryLoanNotes) ? "" : loanLibraryLoanItem.loanLibraryLoanNotes,
        dateSubmitted: loanLibraryLoanItem.dateCreatedUtc ? convertDateToPrintString(loanLibraryLoanItem.dateCreatedUtc) : "",
        dueDate: dueDate,
        dueDateFormatted: dueDate ? convertDateToPrintString(dueDate) : "",
        checkedOutDate: checkedOutDate,
        checkedOutDateFormatted: checkedOutDate ? convertDateToPrintString(checkedOutDate) : "",
        catalogNumber: loanLibraryLoanItem.catalogNumber || "",
        catalogItemTitle: loanLibraryLoanItem.catalogItemTitle || "",
        serialNumber: loanLibraryLoanItem.serialNumber || "",
        assetNumber: loanLibraryLoanItem.assetNumber || "",
        inventoryShortId: loanLibraryLoanItem.inventoryShortId || "",
        patronFullName: loanLibraryLoanItem.patronFullName || "",
        patronEmail: loanLibraryLoanItem.patronEmail || "",
        shippingLocationName: loanLibraryLoanItem.shippingLocationName || "",
        shippingLocation: loanLibraryLoanItem.shippingLocation || null,
        shelfLocation: loanLibraryLoanItem.shelfLocation || "",
        loanItemNotes: loanLibraryLoanItem.loanItemNotes || "",
        loanLibraryCatalogItemId: loanLibraryLoanItem.loanLibraryCatalogItemId || null,
        loanLibraryCatalogItem: loanLibraryLoanItem.loanLibraryCatalogItem || null,
        isOverdue: loanLibraryLoanItem.isOverdue || false,
        daysOverdue: loanLibraryLoanItem.daysOverdue || 0,
        numberOfExtensionDays: loanLibraryLoanItem.numberOfExtensionDays ?? null,
    };
};

export const updateLoanLibraryLoanItemModel = ({
                                                   loanLibraryLoanId,
                                                   loanLibraryLoanStatus,
                                                   loanLibraryLoanNotes,
                                                   numberOfExtensionDays,
                                                   loanItemNotes,
                                                   loanLibraryCatalogItemId,
                                                    loanLibraryCatalogItem,
                                                }: Partial<LoanLibraryLoanItem> = {}) => ({
    LoanLibraryLoanId: loanLibraryLoanId != null ? loanLibraryLoanId : null,
    LoanLibraryLoanStatus: loanLibraryLoanStatus != null ? loanLibraryLoanStatus : null,
    LoanLibraryLoanNotes: isNullOrUndefined(loanLibraryLoanNotes) ? "" : loanLibraryLoanNotes,
    NumberOfExtensionDays: numberOfExtensionDays ?? null,
    LoanItemNotes: isNullOrUndefined(loanItemNotes) ? "" : loanItemNotes,
    LoanLibraryCatalogItemId: loanLibraryCatalogItemId != null ? loanLibraryCatalogItemId : null,
    LoanLibraryCatalogItem: loanLibraryCatalogItem != null ? loanLibraryCatalogItem : null,
});

